<template>
    <Breadcrumbs main="Editor" title="Simple Editor" />
    <div class="container-fluid">
        <div class="row">
            <Card9 colClass="col-md-12 " cardhaderClass="pb-0 title-header" title="Simple Editor">
                <quill-editor v-model:value="state.content" :options="state.editorOption"
                    @change="onEditorChange($event)" />
            </Card9>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { reactive, defineAsyncComponent } from 'vue'
const Card9 = defineAsyncComponent(() => import("@/components/commen/card/cardData9.vue"))
const state = reactive({
    content: '<h1>Some initial content</h1>',
    _content: '',
    editorOption: {
        placeholder: 'core',
    },
    disabled: false
})
const onEditorChange = (html: string) => {

    state._content = html
}
setTimeout(() => {
    state.disabled = true
}, 2000)
</script>